import "./adjust-financial-plan-modal.scss";
import { useEffect, useRef } from "react";
import { SectionCard } from "../../card";
import { StepperItem } from "../../stepper";
import { P2Button, P2TextDescription } from "react-bootstrap-common-script";
import AmountContainerItem from "../amount-container-item/amount-container-item";
import AdjustProposedPaymentAllocationSection from "../adjust-financial-plan/adjust-proposed-payment-allocation";
import AdjustProposedRepaymentPlanSection from "../adjust-financial-plan/adjust-proposed-repayment-plan";
import { Separator } from "../../separator";
import AdjustFeePayable from "../adjust-financial-plan/adjust-fee-payable";
import { useFinancialPlanContext } from "../../../context/financial-plan-contenxt";
import { Helpers } from "../../../utils/helper";

interface AdjustFinancialPlanModalInterface {
  activeStep: string;
  toggleAdjustFPVisibility?: () => void;
}

const AdjustFinancialPlanModal = ({ ...props }: AdjustFinancialPlanModalInterface) => {
  const {
    constant: { total_payable },
    loanDetail,
    derivedValue: { payableByCpfIncludingFees, payableByCash },
  } = useFinancialPlanContext();
  const ContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let top = ContainerRef.current?.getBoundingClientRect().top ?? 0;
    window.scrollTo(0, top);
  }, [ContainerRef]);

  return (
    <div ref={ContainerRef}>
      <div className="polymer-adjust-financial-plan-modal__backdrop"></div>
      <div className="polymer-adjust-financial-plan-modal__content">
        <SectionCard
          required={false}
          className="flex-fill"
          titleChildren={
            <>
              <StepperItem variant="section_active" size={40} step={"4"} marginBottom={"0px"} />
              <P2TextDescription title={"Proposed Owners' Financial Plan"} />
            </>
          }
          contentChildren={
            <div className="polymer-stage-d-financial-plan-container">
              <div className="px-4">
                <AdjustProposedPaymentAllocationSection />
              </div>
              <Separator variant="solid" style={{ margin: "48px 0 24px" }} />
              <div className="px-4">
                <AdjustProposedRepaymentPlanSection />
              </div>
              <Separator variant="solid" style={{ margin: "48px 0 24px" }} />
              <div className="px-4">
                <AdjustFeePayable />
              </div>
            </div>
          }
        />
      </div>

      <div className="polymer-adjust-financial-plan-modal__sticky-container">
        <div className="polymer-adjust-financial-plan-modal__amount-list">
          <AmountContainerItem title="Total payable" amount_value={Helpers.formatThousandSeparator(total_payable.toFixed(2), "S$")} />
          <p className="polymer-adjust-financial-plan-modal__operator">=</p>
          <AmountContainerItem title="Payable by CPF (Inclusive of fees)" amount_value={Helpers.formatThousandSeparator(payableByCpfIncludingFees.toFixed(2), "S$")} />
          <p className="polymer-adjust-financial-plan-modal__operator">+</p>
          <AmountContainerItem title="Payable by Loan" amount_value={Helpers.formatThousandSeparator(loanDetail.loan_val.toFixed(2), "S$")} />
          <p className="polymer-adjust-financial-plan-modal__operator">+</p>
          <AmountContainerItem title="Payable by Cash" amount_value={Helpers.formatThousandSeparator(payableByCash.toFixed(2), "S$")} />
        </div>
        <div className="polymer-adjust-financial-plan-modal__button-group">
          <P2Button variant={"primary-1"} onClick={() => {}}>
            Save changes
          </P2Button>
          <P2Button variant={"outline-primary"} onClick={() => {}}>
            Cancel
          </P2Button>
        </div>
      </div>
    </div>
  );
};

export default AdjustFinancialPlanModal;
